import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'emptyArray',
    standalone: true
})
export class EmptyArrayPipe implements PipeTransform {
    transform(args: unknown[]): boolean {
        return args.length === 0;
    }
}
